import { render, staticRenderFns } from "./Dashboard/Dashboard.html?vue&type=template&id=2320ec06&scoped=true&external"
import script from "./Dashboard/Dashboard?vue&type=script&lang=js&external"
export * from "./Dashboard/Dashboard?vue&type=script&lang=js&external"
import style0 from "./Dashboard/Dashboard.scss?vue&type=style&index=0&id=2320ec06&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2320ec06",
  null
  
)

export default component.exports